import { useId as _useId } from 'vue'

export const useId = _useId as () => string
